import { Typography } from "@mui/material"

export type SelectCaseProps = {
    caseId: string,
    name: string, 
        onChange: (s: string) => void, 
    [rest: string]: any,
}

export default ({ caseId, name, onChange, ...rest }: SelectCaseProps) => {

    return (
       <Typography sx={{background: "lightblue", textAlign: "center", border: "1px solid black", padding: "6px", borderRadius: "10px"}}>{name}</Typography> 
    )
}